import { render, staticRenderFns } from "./ForumDetail.vue?vue&type=template&id=1274dce9&scoped=true"
import script from "./ForumDetail.vue?vue&type=script&lang=js"
export * from "./ForumDetail.vue?vue&type=script&lang=js"
import style0 from "./ForumDetail.vue?vue&type=style&index=0&id=1274dce9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1274dce9",
  null
  
)

export default component.exports